import { createRoute, type AnyRoute } from "@tanstack/react-router";
import { Network } from "lucide-react";

import type { FeatureModule } from "@/features/types";
import { guarded } from "@/lib/auth";

import { ParentCompaniesPage } from "./pages/ParentCompaniesPage";

/** Search params on /parent-companies. Drawer + tab state live in the URL. */
export interface ParentCompaniesSearch {
  company?: string;
  expanded?: boolean;
  tab?: "companies" | "approvals" | "changelog" | "ai-review";
}

function validateSearch(raw: Record<string, unknown>): ParentCompaniesSearch {
  const out: ParentCompaniesSearch = {};
  if (typeof raw.company === "string" && raw.company.length > 0) {
    out.company = raw.company;
  }
  if (raw.expanded === true || raw.expanded === "1" || raw.expanded === "true") {
    out.expanded = true;
  }
  if (raw.tab === "approvals" || raw.tab === "changelog" || raw.tab === "ai-review") {
    out.tab = raw.tab;
  }
  return out;
}

export const parentCompaniesModule: FeatureModule = {
  key: "parent_companies",
  nav: {
    label: "Parent Companies",
    icon: Network,
    to: "/parent-companies",
    requires: "parent_companies.read",
    order: 5,
    group: "Monitors",
  },
  routes: (rootRoute) => [
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/parent-companies",
      component: guarded("parent_companies.read", ParentCompaniesPage),
      validateSearch,
    }),
  ] as unknown as AnyRoute[],
};
